import {
  FETCH_STATUS_FAILED,
  FETCH_STATUS_NONE,
  FETCH_STATUS_PENDING,
  FETCH_STATUS_SUCCESS,
  FetchStatus,
} from '@neptune/shared/common-domain';
import { ProjectWithRole } from '@neptune/shared/core-project-domain';

import { UpdateProjectActionTypes } from 'state/projects/actions';

import { CurrentProjectAction, FetchCurrentProjectActionTypes } from './actions';

export type CurrentProjectState = {
  fetchStatus: FetchStatus;
  project?: ProjectWithRole;
  error: unknown | null;
  requestedId: string;
  lastManuallyUpdated: number;
};

const initialState: CurrentProjectState = {
  fetchStatus: FETCH_STATUS_NONE,
  project: undefined,
  error: null,
  requestedId: '',
  lastManuallyUpdated: 0,
};

type HandledActions =
  | CurrentProjectAction
  | {
      type: UpdateProjectActionTypes.success;
      payload: {
        project: ProjectWithRole;
      };
    };

export function currentProjectReducer(
  state: CurrentProjectState = initialState,
  action: HandledActions,
): CurrentProjectState {
  switch (action.type) {
    case FetchCurrentProjectActionTypes.request: {
      return {
        ...state,
        fetchStatus: FETCH_STATUS_PENDING,
        requestedId: action.payload.projectIdentifier,
        error: null,
      };
    }

    case FetchCurrentProjectActionTypes.success: {
      return {
        ...state,
        fetchStatus: FETCH_STATUS_SUCCESS,
        project: action.payload,
      };
    }

    case FetchCurrentProjectActionTypes.fail: {
      return {
        ...state,
        fetchStatus: FETCH_STATUS_FAILED,
        error: action.error,
        project: undefined,
      };
    }

    case UpdateProjectActionTypes.success: {
      if (!state.project || state.project.id !== action.payload.project.id) {
        return state;
      }

      return {
        ...state,
        project: action.payload.project,
        lastManuallyUpdated: state.lastManuallyUpdated + 1,
      };
    }

    default:
      return state;
  }
}
